module.exports = __webpack_public_path__ + "img/orbit-card-total-token-rewards.b8a513cc.png";